import Classes from "pages/Classes";
import { Directory } from "pages/Directory/Directory";
import Events from "pages/Events";
import { EventLink } from "pages/ExternalLinkEvents";
import { Event } from "pages/ExternalLinkEvents/Event";
import { ReservationEventPage } from "pages/ExternalLinkEvents/EventComponents/ReservationEventPage/ReservationEventPage";
import { FormLink } from "pages/ExternalLinkForms";
import { Form } from "pages/ExternalLinkForms/Form";
import { ReservationFormPage } from "pages/ExternalLinkForms/FormComponents/ReservationFormPage/ReservationFormPage";
import { SchoolLink } from "pages/ExternalLinkSchool";
import FamilyMembersTab from "pages/FamilyMembers";
import HomePage from "pages/home/HomePage";
import JoinSchool from "pages/MemberLink/JoinSchool/JoinSchool";
import MemberLink from "pages/MemberLink/MemberLink";
import { ChargesLink } from "pages/MemberLink/PayFromExternalLink";
import SettingsPage from "pages/Settings";
import Yahrzeit from "pages/Yahrzeit/index";
import { InitialMemberPage } from "pages/auth";
import { CheckValidUser } from "pages/auth/LogoutWrapper";
import Billing from "pages/billing";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ExternalLinkDonation from "../pages/ExternalLinkDonation";
import AddNewMember from "../pages/home/AddNewMember";
import EnabledMemberRoute from "./EnabledMemberRoute";

const routes = [
  {
    path: "/",
    name: "Setup",
    exact: true,
    page: <InitialMemberPage />,
  },
  {
    path: "/check-valid-user",
    name: "CheckValidUser",
    page: <CheckValidUser />,
  },
  {
    path: "/settings",
    name: "SettingsPage",
    page: <SettingsPage />,
    enableModuleKey: "enableSettings",
  },
  {
    path: "/home",
    name: "Home",
    page: <HomePage />,
  },
  {
    path: "/family-member-table",
    name: "FamilyMembersTab",
    page: <FamilyMembersTab />,
    enableModuleKey: "enableMembers",
  },
  {
    path: "/yahrzeit",
    name: "Yahrzeit",
    page: <Yahrzeit />,
    enableModuleKey: "enableYahrzeit",
  },
  // {
  //   path: "/add-yahrzeit",
  //   name: "AddYahrzeit",
  //   page: <AddYahrzeit />,
  // },
  {
    path: "/finance",
    name: "Finance",
    page: <Billing />,
    enableModuleKey: "enableBilling",
  },
  {
    path: "/events-view",
    name: "Events",
    page: <Events />,
    enableModuleKey: "enableEvents",
  },
  // {
  //   path: "/donationPage",
  //   name: "Donation",
  //   page: <Donation />,
  // },
  {
    path: "/directory",
    name: "Directory",
    page: <Directory />,
  },
  // {
  //   path: "/schools-part",
  //   name: "school",
  //   page: <Schools />,
  // },
  {
    path: "/classes",
    name: "classes",
    page: <Classes />,
    enableModuleKey: "enableEducation",
  },
  {
    path: "/add-new-member",
    name: "AddNewMember",
    page: <AddNewMember />,
  },
  // {
  //   path: "/help",
  //   name: "Help",
  //   page: <Help />,
  // },
  {
    path: "/donation-view",
    name: "ExternalLinkDonation",
    page: <ExternalLinkDonation external={false} />,
    enableModuleKey: "enableDonations",
  },

  {
    path: "/school",
    name: "ListOfClasses",
    page: <SchoolLink />,
  },
  {
    path: "/school/:id",
    name: "JoinSchool",
    page: <JoinSchool />,
  },
  {
    path: "/school/:id/register",
    name: "MemberLink",
    page: <MemberLink />,
  },
  {
    path: "/events",
    name: "events",
    page: <EventLink />,
  },
  {
    path: "/events/:id",
    name: "events",
    page: <Event />,
  },
  {
    path: "/events/:id/reservation",
    name: "ReservationEventPage",
    page: <ReservationEventPage />,
  },
  {
    path: "/form",
    name: "forms",
    page: <FormLink />,
  },
  {
    path: "/form/:id",
    name: "forms",
    page: <Form />,
  },
  {
    path: "/form/:id/reservation",
    name: "ReservationFormPage",
    page: <ReservationFormPage />,
  },
  {
    path: "/charges",
    name: "charges",
    page: <ChargesLink />,
  },
  {
    path: "404",
    page: () => null,
  },
];

export const HomeRouters = () => {
  return (
    <>
      <Switch>
        {/* {localStorage.getItem("redirectUrl") && (
          <Redirect
            path="/"
            to={localStorage.getItem("redirectUrl")}
            exact
          />
        )} */}
        {routes.map((route, index) => {
          if (route.enableModuleKey) {
            return (
              <EnabledMemberRoute
                key={index}
                path={route.path}
                exact={route.exact}
                page={route.page}
                enableModuleKey={route.enableModuleKey}
              />
            );
          }
          return (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              render={() => route.page}
            />
          );
        })}
        <Redirect path="*" to="/" />
      </Switch>
    </>
  );
};
